import * as Types from './mutation-types'
import {
  getPermissionQuery
} from './queries.graphql'
import gqlClient from '@/modules/graphql'
import api from "@/modules/api";

const actions = {
  async getPermissions({ commit }) {
    try {
      commit(Types.GET_PERMISSIONS_BEGIN)
      const {
        data: {
          data: {
            universal: {
              permissions
            }
          }
        }
      } = await gqlClient.query({
        query : getPermissionQuery
      })
      
      commit(Types.GET_PERMISSIONS_SUCCESS, permissions)
    } catch (e) {
      commit(Types.GET_PERMISSIONS_ERROR, e)
    }

  },
  async getAssignedPermissions({ commit }, { positionId }){
    commit(Types.GET_ASSIGNED_PERMISSIONS_BEGIN)

    try {
      const { data } = await api.position.getAssignedPermissions(positionId)

      commit(Types.GET_ASSIGNED_PERMISSIONS_SUCCESS, data)
    } catch (error) {
      commit(Types.GET_ASSIGNED_PERMISSIONS_ERROR, error)
    }
  },
  async assignPermissionsToPosition({ commit }, { positionId, permissions }){
    commit(Types.ASSIGN_PERMISSION_BEGIN)

    try {
      await api.position.addPermissions(positionId, permissions)
      commit(Types.ASSIGN_PERMISSION_SUCCESS)
    } catch (error) {
      commit(Types.ASSIGN_PERMISSION_ERROR, error)
    }
  },
  async unassignPermissionsForPosition({ commit }, { positionId }){
    commit(Types.UNASSIGN_PERMISSION_BEGIN)

    try {
      await api.position.deletePermissions(positionId)

      commit(Types.UNASSIGN_PERMISSION_SUCCESS)
    } catch (error) {
      commit(Types.UNASSIGN_PERMISSION_ERROR, error)
    }
  }

}

export default actions
